import { render } from "./SupplierSummaryCard.vue?vue&type=template&id=30a19b8e"
import script from "./SupplierSummaryCard.vue?vue&type=script&lang=js"
export * from "./SupplierSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__